import { render, staticRenderFns } from "./NewVisitorsReport.vue?vue&type=template&id=c8e00ccc&scoped=true"
import script from "./NewVisitorsReport.vue?vue&type=script&lang=js"
export * from "./NewVisitorsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e00ccc",
  null
  
)

export default component.exports